export default {
  body: {
    cmpt: {
      type: 'CCabinetOrderDetail'
    }
  }
}
